<template>
  <div class="mobile-wxdev-box">
    <div class="mobile-en-title">{{ "WeChat".toUpperCase() }}</div>
    <div class="mobile-cn-title">微信平台开发</div>
    <div class="mobile-content" v-html="cleanHtmlText(data.content)"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
